import { FunctionComponent, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, SubmitHandler } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { Button } from "../../generic";
import { auth, forms } from "src/utils";
import { TextInputWithRegister } from "../../inputs";

interface IConfirmAccountFormProps {
    email: string;
    cusId: string;
    tier: string;
}

const ConfirmAccountForm: FunctionComponent<IConfirmAccountFormProps> = ({ email, cusId, tier }) => {
    const navigate = useNavigate();
    const [error, setError] = useState<string>('');
    
    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        defaultValues: {
            email: email || "",
            code: ""
        },
        resolver: yupResolver(forms.schema.ConfirmAccountSchema)
    });

    const submit: SubmitHandler<any> = async (data) => {
        const { email, code } = data;

        try {
            await auth.cognito.verifyCognitoUser(email, code);

            navigate(`/auth/subscription-payment?scid=${cusId}&type=ia&tier=${tier}`);
        } catch (error: any) {
            setError(error?.message || 'Failed to Confirm Account');
        }
    }
    
    return (
        <form>
            <p>Check Your Email for Verification Code</p>
            {error && <p>{error}</p>}
            <TextInputWithRegister
                label='Email'
                id='email'
                placeholder='Email address...'
                containerStyles='lg:w-[85%]'
                register={register('email')}
                error={errors?.email?.message}
            />

            <TextInputWithRegister
                label='Code'
                id='code'
                placeholder='Verification Code...'
                containerStyles='lg:w-[85%]'
                register={register('code')}
                error={errors?.code?.message}
            />

            <Button text="Submit" onClick={handleSubmit(submit)} />

            <div className='flex flex-col'>
                <span onClick={() => { auth.cognito.resendVerificationCode(email || "") }}>
                    Resend Code
                </span>
            </div>
        </form>
    )
}

export default ConfirmAccountForm;